import * as z from 'zod/mini'

/** Join a premise as its customer - the caller, and/or child users they manage. */
export const joinEntityBody = z.object({
  userIds: z.array(z.uuid()).check(z.minLength(1)),
})
export type JoinEntityBody = z.infer<typeof joinEntityBody>

/** No endpoint takes this yet (`POST client/entities/entity/can-join` is commented out); the answer is `CanJoinEntityResponse`. */
export const canJoinEntityBody = z.object({
  shortId: z.string().check(z.minLength(1)),
  userIds: z.array(z.uuid()),
})
export type CanJoinEntityBody = z.infer<typeof canJoinEntityBody>
